import { render, staticRenderFns } from "./HeroImg.vue?vue&type=template&id=4b1b3d1c&scoped=true&"
import script from "./HeroImg.vue?vue&type=script&lang=js&"
export * from "./HeroImg.vue?vue&type=script&lang=js&"
import style0 from "./HeroImg.vue?vue&type=style&index=0&id=4b1b3d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b3d1c",
  null
  
)

export default component.exports